/**
 * Calculateur de prix pour les affiches (impression risographie).
 *
 * Constantes de tarification extraites de :
 *   Fichier source : "Calculateur.xlsx"
 *   Feuilles : "Calculateur Affiche" (formules) + "Nouveaux tarifs" (barèmes)
 *   Date d'extraction : 2026-07-18
 *
 * Toute évolution de tarif doit être répercutée depuis ce fichier Excel.
 */
(function () {
  'use strict';

  var HOURLY_RATE = 50;
  var WASTE_FACTOR = 0.15;
  var BRACKETS = [20, 50, 100, 250, 500];

  var FORMAT_DIVISORS = {
    'A3': 1,
    'A4': 2,
    'A5': 4,
    'A6': 8,
    'Carte de visite': 12
  };

  var PAPER_PRICES = {
    'Munken Print White 80g':  [0.13, 0.12, 0.10, 0.09, 0.07],
    'Munken Print White 90g':  [0.18, 0.16, 0.14, 0.13, 0.10],
    'Munken Print White 120g': [0.24, 0.22, 0.19, 0.17, 0.14],
    'Munken Print White 150g': [0.29, 0.27, 0.23, 0.21, 0.17],
    'Munken Polar Rough 240g': [0.49, 0.45, 0.38, 0.35, 0.28],
    'Munken Polar Rough 300g': [0.73, 0.66, 0.57, 0.52, 0.41]
  };

  var MASTER_FIRST_COLOR = [5, 4.5, 4, 3, 1.5];
  var MASTER_OTHER_COLOR = [10, 9, 8, 6, 3];
  var CALAGE_COST = [15, 15, 20, 22.5, 25];

  var INK_PRICE_PER_PASS = 0.10;
  var VERIF_COST = 0.2 * HOURLY_RATE;
  var RECTO_VERSO_SURCHARGE = 15;
  var IMPRESSION_FIXED_COST = 25;
  var CORNERS_PRICE_PER_UNIT = 4 * 0.005;

  var MASSICOT_NO_BLEED = {'A3': 0, 'A4': 2 * 1, 'A5': 2 * 2, 'A6': 2 * 4, 'Carte de visite': 2 * 12};
  var MASSICOT_BLEED    = {'A3': 0, 'A4': 2 * 6, 'A5': 2 * 8, 'A6': 2 * 12, 'Carte de visite': 2 * 12};

  // Sous ce nombre de passages en A3, l'encre n'a pas le temps de se
  // stabiliser sur le tambour (c'est aussi le premier palier tarifaire
  // ci-dessus) : la quantité minimum affichée dépend donc du format.
  var MIN_PRINT_PASSES = 20;

  function round2(n) {
    return Math.round(n * 100) / 100;
  }

  function minQuantityForFormat(format) {
    return MIN_PRINT_PASSES * FORMAT_DIVISORS[format];
  }

  /**
   * Equivalent to Excel's MATCH(value, brackets, 1): returns the index of
   * the largest bracket <= value. Clamps below the first bracket (instead
   * of Excel's #N/A) and above the last one, so the calculator never
   * errors out on a visitor.
   */
  function matchBracket(value, brackets) {
    var idx = 0;
    for (var i = 0; i < brackets.length; i++) {
      if (brackets[i] <= value) {
        idx = i;
      } else {
        break;
      }
    }
    return idx;
  }

  function computeQuote(input) {
    var format = input.format;
    var quantite = input.quantite;
    var papier = input.papier;
    var couleursRecto = input.couleursRecto;
    var couleursVerso = input.couleursVerso;
    var verification = input.verification;
    var coinsArrondis = input.coinsArrondis;
    var fondPerdu = input.fondPerdu;
    var massicot = input.massicot;

    var nbA3 = Math.ceil((quantite / FORMAT_DIVISORS[format]) * (1 + WASTE_FACTOR));
    var bracketIdx = matchBracket(nbA3, BRACKETS);
    var totalColors = couleursRecto + couleursVerso;

    var calage = totalColors >= 1 ? (totalColors - 1) * CALAGE_COST[bracketIdx] : 0;
    var timeCost = IMPRESSION_FIXED_COST + calage + (couleursVerso > 0 ? RECTO_VERSO_SURCHARGE : 0);
    var verifCost = verification ? VERIF_COST : 0;
    var paperCost = nbA3 * PAPER_PRICES[papier][bracketIdx];
    var inkCost = nbA3 * (couleursRecto + couleursVerso) * INK_PRICE_PER_PASS;
    var masterCost = (totalColors >= 1 ? MASTER_FIRST_COLOR[bracketIdx] : 0)
      + (totalColors > 1 ? (totalColors - 1) * MASTER_OTHER_COLOR[bracketIdx] : 0);
    var cornersCost = coinsArrondis ? quantite * CORNERS_PRICE_PER_UNIT : 0;
    var massicotCost = massicot ? (fondPerdu ? MASSICOT_BLEED[format] : MASSICOT_NO_BLEED[format]) : 0;

    var total = round2(timeCost + verifCost + paperCost + inkCost + masterCost + cornersCost + massicotCost);

    return {
      nbA3: nbA3,
      bracketIdx: bracketIdx,
      timeCost: timeCost,
      verifCost: verifCost,
      paperCost: paperCost,
      inkCost: inkCost,
      masterCost: masterCost,
      cornersCost: cornersCost,
      massicotCost: massicotCost,
      total: total,
      perUnit: round2(total / quantite)
    };
  }

  // Exposed for manual console testing.
  window.__risonnableComputeQuote = computeQuote;

  // Exemples de prix du texte de /devis/ : le HTML garde un prix de secours
  // (lu par Google), recalculé ici pour suivre les tarifs du calculateur.
  document.addEventListener('DOMContentLoaded', function () {
    var fmt = new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'});
    document.querySelectorAll('[data-price-example]').forEach(function (row) {
      var quote = computeQuote({
        format: row.dataset.format,
        quantite: +row.dataset.quantite,
        papier: row.dataset.papier,
        couleursRecto: +row.dataset.couleurs,
        couleursVerso: 0,
        verification: false,
        coinsArrondis: false,
        fondPerdu: false,
        massicot: false
      });
      row.querySelector('[data-price-total]').textContent = fmt.format(quote.total);
      row.querySelector('[data-price-unit]').textContent = fmt.format(quote.perUnit);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var calc = document.getElementById('calculateur');
    if (!calc) {
      return;
    }

    var els = {
      format: document.getElementById('calc-format'),
      quantite: document.getElementById('calc-quantite'),
      papier: document.getElementById('calc-papier'),
      couleursRecto: document.getElementById('calc-couleurs-recto'),
      couleursVerso: document.getElementById('calc-couleurs-verso'),
      verification: document.getElementById('calc-verification'),
      preparation: document.getElementById('calc-preparation'),
      coinsArrondis: document.getElementById('calc-coins-arrondis'),
      fondPerdu: document.getElementById('calc-fond-perdu'),
      massicot: document.getElementById('calc-massicot')
    };

    var summaryEl = document.getElementById('calc-summary');
    var priceTotalEl = document.getElementById('calc-price-total');
    var pricePerUnitFullEl = document.getElementById('calc-price-per-unit-full');
    var pricePerUnitShortEl = document.getElementById('calc-price-per-unit-short');
    var minNoteEl = document.getElementById('calc-min-note');
    var prepNoteEl = document.getElementById('calc-prep-note');
    var finitionsGroupEl = document.getElementById('calc-finitions-group');
    var finishDetailsEl = document.getElementById('calc-finish-details');

    var currencyFmt = new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'});

    function readInputs() {
      return {
        format: els.format.value,
        quantite: parseInt(els.quantite.value, 10),
        papier: els.papier.value,
        couleursRecto: parseInt(els.couleursRecto.value, 10) || 0,
        couleursVerso: parseInt(els.couleursVerso.value, 10) || 0,
        verification: els.verification.checked,
        preparation: els.preparation.checked,
        coinsArrondis: els.coinsArrondis.checked,
        fondPerdu: els.fondPerdu.checked,
        massicot: els.massicot.checked
      };
    }

    function setHidden(id, value) {
      var el = document.getElementById(id);
      if (el) {
        el.value = value;
      }
    }

    function syncHiddenFields(inputs, quote) {
      setHidden('hidden-format', inputs.format);
      setHidden('hidden-quantite', inputs.quantite);
      setHidden('hidden-papier', inputs.papier);
      setHidden('hidden-couleurs-recto', inputs.couleursRecto);
      setHidden('hidden-couleurs-verso', inputs.couleursVerso);
      setHidden('hidden-verification', inputs.verification ? 'Oui' : 'Non');
      setHidden('hidden-preparation', inputs.preparation ? 'Oui (sur devis)' : 'Non');
      setHidden('hidden-coins', inputs.coinsArrondis ? 'Oui' : 'Non');
      setHidden('hidden-fond-perdu', inputs.fondPerdu ? 'Oui' : 'Non');
      setHidden('hidden-massicot', inputs.massicot ? 'Oui' : 'Non');
      setHidden('hidden-total', currencyFmt.format(quote.total));
      setHidden('hidden-per-unit', currencyFmt.format(quote.perUnit));
    }

    function updateFinitionsVisibility() {
      var hideFinitions = els.format.value === 'A3';
      if (finitionsGroupEl) {
        finitionsGroupEl.classList.toggle('hidden', hideFinitions);
      }
      if (hideFinitions) {
        els.massicot.checked = false;
      }

      var showFinishDetails = !hideFinitions && els.massicot.checked;
      if (finishDetailsEl) {
        finishDetailsEl.classList.toggle('hidden', !showFinishDetails);
      }
      if (!showFinishDetails) {
        els.fondPerdu.checked = false;
        els.coinsArrondis.checked = false;
      }
    }

    function recalc() {
      updateFinitionsVisibility();

      var inputs = readInputs();
      var minQty = minQuantityForFormat(inputs.format);
      els.quantite.min = String(minQty);

      if (prepNoteEl) {
        prepNoteEl.classList.toggle('hidden', !inputs.preparation);
      }

      var belowMin = Number.isInteger(inputs.quantite) && inputs.quantite < minQty;
      if (minNoteEl) {
        if (belowMin) {
          minNoteEl.textContent = 'Le format ' + inputs.format + ' nécessite au moins ' + minQty
            + ' exemplaires (soit ' + MIN_PRINT_PASSES + ' passages A3 dans la machine) : en dessous, '
            + "l'encrage n'a pas le temps de se stabiliser sur le tambour.";
          minNoteEl.classList.remove('hidden');
        } else {
          minNoteEl.classList.add('hidden');
        }
      }

      if (!Number.isInteger(inputs.quantite) || inputs.quantite < 1 || belowMin) {
        summaryEl.textContent = '';
        priceTotalEl.textContent = '—';
        pricePerUnitFullEl.textContent = '';
        pricePerUnitShortEl.textContent = '';
        return;
      }

      var quote = computeQuote(inputs);
      summaryEl.textContent = inputs.quantite + ' exemplaires en ' + inputs.format;
      priceTotalEl.textContent = currencyFmt.format(quote.total);
      pricePerUnitFullEl.textContent = 'Soit ' + currencyFmt.format(quote.perUnit) + ' / exemplaire';
      pricePerUnitShortEl.textContent = currencyFmt.format(quote.perUnit) + ' / ex.';

      syncHiddenFields(inputs, quote);
    }

    Object.keys(els).forEach(function (key) {
      var el = els[key];
      el.addEventListener('input', recalc);
      el.addEventListener('change', recalc);
    });

    recalc();

    var modal = document.getElementById('contact-modal');
    var modalBackdrop = document.getElementById('contact-modal-backdrop');
    var modalClose = document.getElementById('contact-modal-close');
    var modalTitleEl = document.getElementById('contact-modal-title');
    var modalDevisSummaryEl = document.getElementById('modal-devis-summary');
    var modalDevisSummaryFieldEl = document.getElementById('modal-devis-summary-field');
    var messageInput = document.getElementById('message');
    var messageLabelEl = document.getElementById('message-label');
    var calcHiddenFieldset = document.getElementById('calc-hidden-fields');
    var emailSubjectInput = document.getElementById('email-subject');
    var modalSubmitBtn = document.getElementById('fs-submit');
    var openModalTriggers = document.querySelectorAll('.js-open-modal');

    function openModal(mode) {
      if (!modal) {
        return;
      }
      var isDevis = mode === 'devis';

      modalTitleEl.textContent = isDevis ? 'Demander un devis' : 'Nous contacter';
      messageInput.required = !isDevis;
      messageLabelEl.textContent = isDevis ? 'Message (optionnel)' : 'Message';
      calcHiddenFieldset.disabled = !isDevis;
      if (modalSubmitBtn) {
        modalSubmitBtn.setAttribute('data-umami-event-mode', mode);
      }

      if (isDevis) {
        modalDevisSummaryEl.value = summaryEl.textContent.replace('exemplaires en', 'exemplaires') + ' à ' + priceTotalEl.textContent;
        modalDevisSummaryFieldEl.classList.remove('hidden');
      } else {
        modalDevisSummaryFieldEl.classList.add('hidden');
      }

      var today = new Date().toLocaleDateString('fr-FR', {year: 'numeric', month: 'short', day: 'numeric'});
      emailSubjectInput.value = (isDevis ? 'Nouvelle demande de devis du ' : 'Nouvelle demande de contact du ') + today;

      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!modal) {
        return;
      }
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    openModalTriggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.getAttribute('data-modal-mode'));
      });
    });
    if (modalBackdrop) {
      modalBackdrop.addEventListener('click', closeModal);
    }
    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });

    window.addEventListener('beforeunload', function () {
      var forms = document.getElementsByTagName('form');
      for (var i = 0; i < forms.length; i++) {
        forms[i].reset();
      }
    });
  });
})();
